import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c47f5748&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47f5748",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c47f5748')) {
      api.createRecord('c47f5748', component.options)
    } else {
      api.reload('c47f5748', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c47f5748&scoped=true&", function () {
      api.rerender('c47f5748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Jtg3pW3u5L6q/JS/comp/SearchFilterTokens.vue"
export default component.exports